/**
 * Hero scroll component.
 *
 * Handles smooth scrolling from hero section to the next section.
 *
 * @package   Tibs
 */

document.addEventListener('DOMContentLoaded', function() {
    const scrollLinks = document.querySelectorAll('[data-scroll-to-next-section]');
    
    scrollLinks.forEach(function(link) {
        link.addEventListener('click', function(e) {
            e.preventDefault();
            
            // Find the hero section (parent section of the link)
            const heroSection = link.closest('section');
            
            if (!heroSection) {
                return;
            }
            
            // Find all sections on the page
            const allSections = document.querySelectorAll('section');
            
            // Find the next section after the hero section
            let nextSection = null;
            let foundHero = false;
            
            allSections.forEach(function(section) {
                if (foundHero && !nextSection) {
                    nextSection = section;
                }
                if (section === heroSection) {
                    foundHero = true;
                }
            });
            
            // If we found a next section, scroll to it
            if (nextSection) {
                const targetId = nextSection.id;
                const offsetTop = nextSection.getBoundingClientRect().top + window.pageYOffset;
                
                // Smooth scroll to the next section
                window.scrollTo({
                    top: offsetTop,
                    behavior: 'smooth'
                });
            }
        });
    });
});

